export default __webpack_public_path__ + "static/media/Magsaysay_LEWC.83a4ee1d.png";